import { css, type Theme } from "@emotion/react";

import { animations, helpers, layers, timing } from "@styles";

export const base = (theme: Theme) => css`
  ${animations.transition()};
  background-color: ${theme.surface.overlayTheme};
  padding: 0.5rem 1rem;
  color: ${theme.text.body};
  border-radius: 5px;
  position: fixed;
  z-index: ${layers.indexModalMax};
  box-shadow: 0 4px 16px 0 ${helpers.hexToRgba(theme.system.borderActive, 0.2)};
`;

export const position = {
  topLeft: css`
    top: 2rem;
    left: 2rem;
  `,
  topRight: css`
    top: 2rem;
    right: 2rem;
  `,
  bottomLeft: css`
    bottom: 2rem;
    left: 2rem;
  `,
  bottomRight: css`
    bottom: 2rem;
    right: 2rem;
  `,
};

export const successStatus = (theme: Theme) => css`
  background-color: ${theme.primary.backgroundBox};
  color: ${theme.primary.textBase};
`;

export const spinner = css`
  margin-right: 0.5rem;
  animation-duration: ${timing.slow};
`;
